// extracted by mini-css-extract-plugin
export default {"searchHeader":"SearchHeader__searchHeader","buildingsWithListingsBackground":"SearchHeader__buildingsWithListingsBackground","searchWrapper":"SearchHeader__searchWrapper"};